import React from 'react';
import localization from '@progressivebeef/shared/src/localization/i18n';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import { INSTRUCTION_LENGTH } from '@progressivebeef/shared/src/constants/AppConstants';
import './style.scss';

const RecordInstruction = ({ instructions, expanded, onToggle, truncate, customStyle }) => {
  if (!instructions) return null;
  return (
    <div className="detail-section">
      <div className="detail-label">
        {localization[getLocale()].INSTRUCTIONS}:
      </div>
      <div className="instructions-text" style={customStyle}>
        {expanded ? instructions : truncate(instructions)}
        {instructions.length > INSTRUCTION_LENGTH && (
          <span className="see-more-link" onClick={onToggle}>
            {` ${
              expanded
                ? localization[getLocale()].SEE_LESS
                : localization[getLocale()].SEE_MORE
            }`}
          </span>
        )}
      </div>
    </div>
  );
};

export default RecordInstruction;
